import type { CartItem } from '../../../domain/models';

export const FREE_PRICE_ACCENT = '#F4A261';

export function defaultFreePriceDesignation(categoryName: string): string {
  return `Produit ${categoryName.trim()}`.trim();
}

export function appendFreePriceKey(raw: string, key: string): string {
  if (key === 'backspace') return raw.slice(0, -1);
  if (key === '.' && raw.includes('.')) return raw;
  if (key !== '.' && !/^\d$/.test(key)) return raw;

  const next = raw === '0' && key !== '.' ? key : `${raw}${key}`;
  const [, decimals = ''] = next.split('.');
  if (decimals.length > 3) return raw;
  return next.length <= 10 ? next : raw;
}

export function freePriceAmount(raw: string): number {
  const value = Number.parseFloat(raw);
  return Number.isFinite(value) && value > 0
    ? Math.round(value * 1000) / 1000
    : 0;
}

export function createFreePriceCartItem(input: {
  categoryId: string;
  designation: string;
  priceTtc: number;
  uniqueId?: string;
}): CartItem {
  const designation = input.designation.trim();
  const priceTtc = Math.round(input.priceTtc * 1000) / 1000;
  if (!input.categoryId || !designation || !(priceTtc > 0)) {
    throw new Error('Prix libre requires a category, designation, and positive price');
  }

  const uniqueId =
    input.uniqueId ??
    `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

  return {
    productId: `free-price:${input.categoryId}:${uniqueId}`,
    productName: designation,
    unitPrice: priceTtc,
    taxRate: 0,
    quantity: 1,
    subtotal: priceTtc,
    productDiscountPercentage: 0,
    productDiscountAmount: 0,
    isFreePrice: true,
    categoryId: input.categoryId,
  };
}
